(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion .accordion__header');
    
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const item = this.closest('.accordion__item');
        const content = item.querySelector('.accordion__content');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        // Toggle aria-expanded
        this.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
        
        // Toggle content visibility
        if (isExpanded) {
          content.setAttribute('hidden', '');
        } else {
          content.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('.cart__form');
    if (!form) return;

    form.addEventListener('click', function(e) {
      const btn = e.target.closest('.qty-btn');
      if (!btn) return;
      const container = btn.parentElement;
      const input = container.querySelector('.qty-input');
      const action = btn.dataset.action;
      const current = parseInt(input.value || '0', 10);
      const next = action === 'increment' ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      form.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const countdownSections = document.querySelectorAll('.countdown[data-section-id]');
    
    // Handle body class for fixed countdown
    const fixedCountdowns = document.querySelectorAll('.countdown--above-header:not(.countdown--expired)');
    if (fixedCountdowns.length > 0) {
      document.body.classList.add('countdown-active');
      const countdownHeight = fixedCountdowns[0].offsetHeight;
      document.documentElement.style.setProperty('--countdown-height', countdownHeight + 'px');
    }
    
    countdownSections.forEach(function(countdown) {
      const sectionId = countdown.dataset.sectionId;
      const endDateString = countdown.dataset.endDate;
      const timezone = countdown.dataset.timezone || 'UTC';
      
      if (!endDateString) return;
      
      // Parse end date
      const endDate = new Date(endDateString);
      if (isNaN(endDate.getTime())) {
        console.error('Invalid countdown date:', endDateString);
        return;
      }
      
      const daysEl = countdown.querySelector('[data-days]');
      const hoursEl = countdown.querySelector('[data-hours]');
      const minutesEl = countdown.querySelector('[data-minutes]');
      const secondsEl = countdown.querySelector('[data-seconds]');
      
      let interval;
      
      function updateCountdown() {
        const now = new Date();
        const difference = endDate.getTime() - now.getTime();
        
        if (difference <= 0) {
          // Countdown expired
          countdown.classList.add('countdown--expired');
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          
          // Update body class if this was a fixed countdown
          if (countdown.classList.contains('countdown--above-header')) {
            const remainingFixed = document.querySelectorAll('.countdown--above-header:not(.countdown--expired)');
            if (remainingFixed.length === 0) {
              document.body.classList.remove('countdown-active');
            }
          }
          
          if (interval) {
            clearInterval(interval);
          }
          return;
        }
        
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
      }
      
      // Update immediately
      updateCountdown();
      
      // Update every second
      interval = setInterval(updateCountdown, 1000);
      
      // Handle close button
      const closeButton = countdown.querySelector('[data-countdown-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          countdown.style.display = 'none';
          // Store in localStorage to remember user's choice
          localStorage.setItem('countdown-closed-' + sectionId, 'true');
          
          // Update body class if this was a fixed countdown
          if (countdown.classList.contains('countdown--above-header')) {
            const remainingFixed = document.querySelectorAll('.countdown--above-header:not([style*="display: none"])');
            if (remainingFixed.length === 0) {
              document.body.classList.remove('countdown-active');
            }
          }
        });
      }
      
      // Check if user previously closed this countdown
      if (localStorage.getItem('countdown-closed-' + sectionId) === 'true') {
        countdown.style.display = 'none';
        document.body.classList.remove('countdown-active');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  // Handle country/province selection
  (function() {
    const customerAddressFormNew = document.getElementById('customer_address_form_new');
    const countrySelects = document.querySelectorAll('[id^="address_country"]');
    
    countrySelects.forEach(function(countrySelect) {
      const formId = countrySelect.id.replace('address_country_', '');
      const provinceContainer = document.getElementById('address_province_container_' + formId);
      const provinceSelect = document.getElementById('address_province_' + formId);
      
      if (!provinceContainer || !provinceSelect) return;
      
      function updateProvinceSelect() {
        const selectedOption = countrySelect.options[countrySelect.selectedIndex];
        const provinces = selectedOption ? selectedOption.getAttribute('data-provinces') : null;
        
        if (provinces && provinces.length > 0) {
          try {
            const provincesArray = JSON.parse(provinces);
            provinceSelect.innerHTML = '<option value="">' + customerAddressFormNew.dataset.defaultProvince + '</option>';
            
            provincesArray.forEach(function(province) {
              const option = document.createElement('option');
              option.value = province[0];
              option.textContent = province[1];
              if (provinceSelect.dataset.default === province[0]) {
                option.selected = true;
              }
              provinceSelect.appendChild(option);
            });
            
            provinceContainer.style.display = 'block';
            provinceSelect.required = true;
          } catch (e) {
            console.error('Error parsing provinces:', e);
            provinceContainer.style.display = 'none';
            provinceSelect.required = false;
          }
        } else {
          provinceContainer.style.display = 'none';
          provinceSelect.required = false;
          provinceSelect.innerHTML = '';
        }
      }
      
      countrySelect.addEventListener('change', updateProvinceSelect);
      
      // Trigger change on load if country is selected
      if (countrySelect.value) {
        updateProvinceSelect();
      }
    });
  })();

  // Handle edit address
  (function() {
    const editButtons = document.querySelectorAll('.customer-addresses__edit');
    const cancelButton = document.querySelector('.customer-addresses__cancel');
    const formTitle = document.getElementById('customer-addresses-form-title');
    const form = document.getElementById('address_form_new');
    
    editButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const addressId = this.dataset.addressId;
        const addressElement = document.querySelector('[data-address-id="' + addressId + '"]');
        
        if (!addressElement) return;
        
        // Get address data from data attributes
        const addressData = {
          first_name: addressElement.dataset.addressFirstName || '',
          last_name: addressElement.dataset.addressLastName || '',
          company: addressElement.dataset.addressCompany || '',
          address1: addressElement.dataset.addressAddress1 || '',
          address2: addressElement.dataset.addressAddress2 || '',
          city: addressElement.dataset.addressCity || '',
          province: addressElement.dataset.addressProvince || '',
          zip: addressElement.dataset.addressZip || '',
          country: addressElement.dataset.addressCountry || '',
          phone: addressElement.dataset.addressPhone || '',
          default: addressElement.dataset.addressDefault === 'true'
        };
        
        // Update form action
        form.action = '/account/addresses/' + addressId;
        form.method = 'post';
        
        // Add hidden method field
        let methodField = form.querySelector('input[name="_method"]');
        if (!methodField) {
          methodField = document.createElement('input');
          methodField.type = 'hidden';
          methodField.name = '_method';
          form.appendChild(methodField);
        }
        methodField.value = 'put';
        
        // Populate fields
        Object.keys(addressData).forEach(function(key) {
          if (key === 'default') {
            const checkbox = form.querySelector('#address_default_address_new');
            if (checkbox) {
              checkbox.checked = addressData[key];
            }
          } else {
            const field = form.querySelector('[name="address[' + key + ']"]');
            if (field) {
              field.value = addressData[key];
            }
          }
        });
        
        // Handle country/province
        const countrySelect = form.querySelector('#address_country_new');
        if (countrySelect && addressData.country) {
          countrySelect.value = addressData.country;
          countrySelect.dispatchEvent(new Event('change'));
          
          // Set province after country change
          setTimeout(function() {
            const provinceSelect = form.querySelector('#address_province_new');
            if (provinceSelect && addressData.province) {
              provinceSelect.value = addressData.province;
            }
          }, 100);
        }
        
        // Update title and button
        if (formTitle) {
          formTitle.textContent = formTitle.dataset.defaultTitle;
        }
        
        if (cancelButton) {
          cancelButton.style.display = 'inline-block';
        }
        
        // Update submit button text
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.textContent = submitButton.dataset.defaultText;
        }
        
        // Jump to form without smooth scrolling.
        form.scrollIntoView({ block: 'start' });
      });
    });
    
    if (cancelButton) {
      cancelButton.addEventListener('click', function() {
        form.action = '/account/addresses';
        form.method = 'post';
        const methodField = form.querySelector('input[name="_method"]');
        if (methodField) {
          methodField.remove();
        }
        
        form.reset();
        
        // Reset country/province
        const countrySelect = form.querySelector('#address_country_new');
        if (countrySelect) {
          countrySelect.value = countrySelect.dataset.default || '';
          countrySelect.dispatchEvent(new Event('change'));
        }
        
        if (formTitle) {
          formTitle.textContent = formTitle.dataset.defaultTitle;
        }
        
        // Reset submit button text
        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.textContent = submitButton.dataset.defaultText;
        }
        
        this.style.display = 'none';
      });
    }
  })();

  // Handle delete confirmation
  (function() {
    const deleteForms = document.querySelectorAll('form[data-confirm-message]');
    
    deleteForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        const message = this.dataset.confirmMessage;
        if (!confirm(message)) {
          e.preventDefault();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-featured-articles-slider]').forEach(function (root) {
      const sliderElement = root.querySelector('.swiper');
      if (!sliderElement) return;

      const slidersPerView = parseFloat(sliderElement.dataset.slidersPerView) || 3.2;
      const prevButton = root.querySelector('.featured-articles__navigation .swiper-button-prev');
      const nextButton = root.querySelector('.featured-articles__navigation .swiper-button-next');

      new Swiper(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 0,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          768: {
            slidesPerView: slidersPerView,
            spaceBetween: 20,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blogs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-featured-blogs-slider]').forEach(function (root) {
      const sliderElement = root.querySelector('.swiper');
      if (!sliderElement) return;

      const slidersPerView = parseFloat(sliderElement.dataset.slidersPerView) || 3.2;
      const prevButton = root.querySelector('.featured-blogs__navigation .swiper-button-prev');
      const nextButton = root.querySelector('.featured-blogs__navigation .swiper-button-next');

      new Swiper(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 0,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          768: {
            slidesPerView: slidersPerView,
            spaceBetween: 20,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() { 
    const sliderElement = document.querySelector('.featured-collection .swiper');
    if (!sliderElement) return;

    const slidersPerView = parseFloat(sliderElement.dataset.slidersPerView) || 3.2;
    const prevButton = document.querySelector('.featured-collection__navigation .swiper-button-prev');
    const nextButton = document.querySelector('.featured-collection__navigation .swiper-button-next');

    const swiper = new Swiper(sliderElement, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 0,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        768: { 
          slidesPerView: slidersPerView,
          spaceBetween: 20
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.hotspots[data-section-id]');
    sections.forEach(function(sectionElement) {
      const sectionId = sectionElement.dataset.sectionId;
      if (!sectionId) return;

      const swiperElement = sectionElement.querySelector('.hotspots__swiper');
      if (!swiperElement || typeof Swiper === 'undefined') return;

      const hotspots = sectionElement.querySelectorAll('.hotspot');
      const prevButton = sectionElement.querySelector('.hotspots__nav--prev');
      const nextButton = sectionElement.querySelector('.hotspots__nav--next');
      const currentSpan = sectionElement.querySelector('.hotspots__current');
      const totalSpan = sectionElement.querySelector('.hotspots__total');

      // Initialize Swiper
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        on: {
          slideChange: function(swiper) {
            const activeIndex = swiper.activeIndex;
            
            // Update active hotspot
            hotspots.forEach(function(hotspot, index) {
              if (index === activeIndex) {
                hotspot.classList.add('active');
              } else {
                hotspot.classList.remove('active');
              }
            });

            // Update pagination
            if (currentSpan) {
              currentSpan.textContent = activeIndex + 1;
            }
          }
        }
      });

      // Handle hotspot clicks
      hotspots.forEach(function(hotspot, index) {
        hotspot.addEventListener('click', function() {
          swiper.slideTo(index);
        });
      });

      // Update navigation button states
      function updateNavigationButtons() {
        if (prevButton) {
          prevButton.disabled = swiper.isBeginning;
        }
        if (nextButton) {
          nextButton.disabled = swiper.isEnd;
        }
      }

      swiper.on('slideChange', updateNavigationButtons);
      updateNavigationButtons();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() { 

    const logosSlider = document.querySelector('.logos .swiper');
    const logosLength = logosSlider.dataset.size;

    const swiper = new Swiper(logosSlider, {
      slidesPerView: "auto",
      spaceBetween: 60,
      centeredSlides: true,
      loop: true,
      speed: 4000,
      allowTouchMove: false,
      initialSlide: logosLength - 1,
      autoplay: {
        delay: 0.5,
        disableOnInteraction: false
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const testimonialsSections = document.querySelectorAll('.testimonials__swiper[data-section-id]');
    
    testimonialsSections.forEach(function(section) {
      const sectionId = section.dataset.sectionId;
      if (!sectionId || typeof Swiper === 'undefined') return;

      const prevButton = section.querySelector('.testimonials__nav--prev');
      const nextButton = section.querySelector('.testimonials__nav--next');

      const slides = section.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      
      new Swiper(section, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: slideCount > 1,
        centeredSlides: true,
        navigation: slideCount > 1 ? {
          nextEl: nextButton,
          prevEl: prevButton,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: Math.min(2, slideCount),
            spaceBetween: 30,
          },
          992: {
            slidesPerView: Math.min(3, slideCount),
            spaceBetween: 30,
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  function videoSectionPauseAllVideos(sectionEl) {
    if (!sectionEl) return;
    sectionEl.querySelectorAll('.video-section__video').forEach(function (v) {
      v.pause();
    });
  }

  function videoSectionPlayActiveIfAutoplay(sectionEl) {
    var autoplay = sectionEl && sectionEl.dataset.videoAutoplay === 'true';
    if (!autoplay) return;
    var active = sectionEl.querySelector('.swiper-slide-active .video-section__video');
    if (!active) return;
    active.play().catch(function () {});
  }

  function initVideoSectionSliders(root, attempt) {
    attempt = attempt || 0;
    var scope = root || document;
    if (!scope.querySelectorAll) scope = document;
    var sectionEls = [];

    if (scope !== document && scope.matches && scope.matches('[data-video-section-slider]')) {
      sectionEls.push(scope);
    }
    scope.querySelectorAll('[data-video-section-slider]').forEach(function (el) {
      if (sectionEls.indexOf(el) === -1) sectionEls.push(el);
    });

    if (typeof Swiper === 'undefined') {
      if (attempt < 60) {
        setTimeout(function () {
          initVideoSectionSliders(root, attempt + 1);
        }, 50);
      }
      return;
    }

    sectionEls.forEach(function (sectionEl) {
      var swiperEl = sectionEl.querySelector('[data-video-swiper]');
      if (!swiperEl || swiperEl.dataset.videoSwiperInitialized === 'true') return;

      var prevButton = sectionEl.querySelector('.video-section__edge-nav--prev');
      var nextButton = sectionEl.querySelector('.video-section__edge-nav--next');

      var sliderAutoplay = sectionEl.dataset.sliderAutoplay === 'true';
      var delayMs = parseInt(sectionEl.dataset.sliderAutoplayDelayMs, 10);
      if (isNaN(delayMs) || delayMs < 2000) delayMs = 5000;

      var swiperParams = {
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 0,
        autoHeight: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.1,
            spaceBetween: 20,
            mousewheel: {
              forceToAxis: false,
              releaseOnEdges: true,
              sensitivity: 1,
              eventsTarget: 'container',
            },
          },
        },
      };

      if (sliderAutoplay) {
        swiperParams.autoplay = {
          delay: delayMs,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      var swiper = new Swiper(swiperEl, swiperParams);

      swiperEl.dataset.videoSwiperInitialized = 'true';

      var bumpAutoHeight = function () {
        swiper.updateAutoHeight(0);
      };

      swiper.on('slideChangeTransitionEnd', bumpAutoHeight);
      sectionEl.querySelectorAll('.video-section__video').forEach(function (vid) {
        vid.addEventListener('loadedmetadata', bumpAutoHeight);
      });
      window.addEventListener('resize', bumpAutoHeight, { passive: true });
      bumpAutoHeight();

      swiper.on('slideChange', function () {
        videoSectionPauseAllVideos(sectionEl);
        window.requestAnimationFrame(function () {
          bumpAutoHeight();
          videoSectionPlayActiveIfAutoplay(sectionEl);
        });
      });
    });
  }

  function initVideoSectionControls(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-custom-video-controls]').forEach(function (mediaBlock) {
      if (mediaBlock.dataset.videoControlsInit === 'true') return;
      mediaBlock.dataset.videoControlsInit = 'true';

      var playButton = mediaBlock.querySelector('[data-video-toggle-play]');
      var muteButton = mediaBlock.querySelector('[data-video-toggle-mute]');
      var overlayPlayButton = mediaBlock.querySelector('[data-video-overlay-play]');
      var shouldAutoplay = mediaBlock.dataset.videoAutoplay === 'true';
      var hasStarted = shouldAutoplay;

      if (!playButton || !muteButton || !overlayPlayButton) return;

      var getActiveVideo = function () {
        var desktopVideo = mediaBlock.querySelector('.video-section__desktop-only .video-section__video');
        var mobileVideo = mediaBlock.querySelector('.video-section__mobile-only .video-section__video');
        var singleVideo = mediaBlock.querySelector('.video-wrapper .video-section__video');

        if (window.matchMedia('(max-width: 991px)').matches && mobileVideo) return mobileVideo;
        if (desktopVideo) return desktopVideo;
        return singleVideo;
      };

      var syncState = function () {
        var video = getActiveVideo();
        if (!video) return;

        var paused = video.paused;
        var muted = video.muted;

        mediaBlock.classList.toggle('is-paused', paused);
        mediaBlock.classList.toggle('is-unmuted', !muted);
        mediaBlock.classList.toggle('is-not-started', !hasStarted);

        playButton.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        muteButton.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      };

      overlayPlayButton.addEventListener('click', function () {
        var video = getActiveVideo();
        if (!video) return;
        hasStarted = true;
        video.play();
        syncState();
      });

      playButton.addEventListener('click', function () {
        var video = getActiveVideo();
        if (!video) return;
        if (video.paused) {
          hasStarted = true;
          video.play();
        } else {
          video.pause();
        }
        syncState();
      });

      muteButton.addEventListener('click', function () {
        var video = getActiveVideo();
        if (!video) return;
        video.muted = !video.muted;
        syncState();
      });

      mediaBlock.querySelectorAll('.video-section__video').forEach(function (video) {
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('volumechange', syncState);
      });

      window.addEventListener('resize', syncState, { passive: true });
      syncState();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideoSectionControls(document);
    initVideoSectionSliders(document);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target) return;
    initVideoSectionControls(ev.target);
    initVideoSectionSliders(ev.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-splash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-welcome-splash]');
    if (!root) return;

    if (document.documentElement.classList.contains('welcome-splash--seen')) {
      return;
    }

    var storageKey = root.dataset.storageKey;
    var desktopUrl = root.dataset.videoDesktop || '';
    var mobileUrl = root.dataset.videoMobile || desktopUrl;
    var url = window.matchMedia('(max-width: 991px)').matches ? mobileUrl : desktopUrl;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var scrollDismissCleanup = null;

    function bindWelcomeScrollDismissOnce() {
      if (root.dataset.welcomeScrollDismissBound === '1') return;
      root.dataset.welcomeScrollDismissBound = '1';

      function welcomeScrollDismissActive() {
        return (
          document.documentElement.classList.contains('welcome-splash--active') &&
          root.classList.contains('welcome-splash--welcome-visible')
        );
      }

      function onWheel(e) {
        if (!welcomeScrollDismissActive()) return;
        if (Math.abs(e.deltaY) < 2 && Math.abs(e.deltaX) < 2) return;
        dismiss({ fade: true, unlockScroll: true });
      }

      var touchStartY = null;
      function onTouchStart(e) {
        if (!welcomeScrollDismissActive()) return;
        if (e.touches.length !== 1) return;
        touchStartY = e.touches[0].clientY;
      }

      function onTouchMove(e) {
        if (touchStartY == null || !e.touches.length) return;
        if (!welcomeScrollDismissActive()) return;
        var dy = e.touches[0].clientY - touchStartY;
        if (Math.abs(dy) > 24) {
          touchStartY = null;
          dismiss({ fade: true, unlockScroll: true });
        }
      }

      function onTouchEnd() {
        touchStartY = null;
      }

      function onWindowScroll() {
        if (!welcomeScrollDismissActive()) return;
        dismiss({ fade: true, unlockScroll: true });
      }

      window.addEventListener('wheel', onWheel, { passive: true });
      root.addEventListener('touchstart', onTouchStart, { passive: true });
      root.addEventListener('touchmove', onTouchMove, { passive: true });
      root.addEventListener('touchend', onTouchEnd, { passive: true });
      window.addEventListener('scroll', onWindowScroll, true);

      scrollDismissCleanup = function () {
        window.removeEventListener('wheel', onWheel);
        root.removeEventListener('touchstart', onTouchStart);
        root.removeEventListener('touchmove', onTouchMove);
        root.removeEventListener('touchend', onTouchEnd);
        window.removeEventListener('scroll', onWindowScroll, true);
      };
    }

    function showWelcome() {
      root.classList.add('welcome-splash--welcome-visible');
      bindWelcomeScrollDismissOnce();
    }

    var fadeDismissFallbackTimer = null;

    function finishDismiss() {
      if (fadeDismissFallbackTimer !== null) {
        clearTimeout(fadeDismissFallbackTimer);
        fadeDismissFallbackTimer = null;
      }
      root.classList.remove('welcome-splash--closing');
      document.documentElement.classList.remove('welcome-splash--unlock-scroll');
      try {
        if (storageKey) window.localStorage.setItem(storageKey, '1');
      } catch (err) {}
      document.documentElement.classList.remove('welcome-splash--active');
      document.documentElement.classList.add('welcome-splash--seen');
    }

    function dismiss(opts) {
      opts = opts || {};
      var wantsFade =
        !!opts.fade &&
        !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      if (!document.documentElement.classList.contains('welcome-splash--active')) {
        return;
      }

      if (scrollDismissCleanup) {
        scrollDismissCleanup();
        scrollDismissCleanup = null;
      }

      if (root.classList.contains('welcome-splash--closing')) {
        if (!wantsFade) {
          if (fadeDismissFallbackTimer !== null) {
            clearTimeout(fadeDismissFallbackTimer);
            fadeDismissFallbackTimer = null;
          }
          root.removeEventListener('transitionend', onSplashFadeEnd);
          finishDismiss();
        }
        return;
      }

      if (!wantsFade) {
        finishDismiss();
        return;
      }

      function onSplashFadeEnd(e) {
        if (e.target !== root) return;
        if (e.propertyName !== 'opacity') return;
        root.removeEventListener('transitionend', onSplashFadeEnd);
        if (fadeDismissFallbackTimer !== null) {
          clearTimeout(fadeDismissFallbackTimer);
          fadeDismissFallbackTimer = null;
        }
        finishDismiss();
      }

      if (opts.unlockScroll) {
        document.documentElement.classList.add('welcome-splash--unlock-scroll');
      }

      root.classList.add('welcome-splash--closing');
      root.addEventListener('transitionend', onSplashFadeEnd);
      fadeDismissFallbackTimer = setTimeout(function () {
        fadeDismissFallbackTimer = null;
        root.removeEventListener('transitionend', onSplashFadeEnd);
        finishDismiss();
      }, 550);
    }

    document.addEventListener('keydown', function splashEscape(e) {
      if (!document.documentElement.classList.contains('welcome-splash--active')) {
        document.removeEventListener('keydown', splashEscape);
        return;
      }
      if (e.key === 'Escape') {
        dismiss({ fade: true });
        document.removeEventListener('keydown', splashEscape);
      }
    });

    if (reduceMotion || !url) {
      showWelcome();
    } else {
      var videoStage = root.querySelector('[data-welcome-splash-video]');
      var mediaBlock = root.querySelector('[data-welcome-splash-media]');
      var playButton = mediaBlock && mediaBlock.querySelector('[data-video-toggle-play]');
      var muteButton = mediaBlock && mediaBlock.querySelector('[data-video-toggle-mute]');
      var overlayPlayButton = mediaBlock && mediaBlock.querySelector('[data-video-overlay-play]');
      var shouldAutoplay = mediaBlock && mediaBlock.dataset.videoAutoplay === 'true';
      var hasStarted = !!shouldAutoplay;

      if (!videoStage || !mediaBlock || !playButton || !muteButton || !overlayPlayButton) {
        showWelcome();
      } else {
        var getVideo = function () {
          return mediaBlock.querySelector('.video-section__video');
        };

        var syncState = function () {
          var video = getVideo();
          if (!video) return;
          var paused = video.paused;
          var muted = video.muted;
          mediaBlock.classList.toggle('is-paused', paused);
          mediaBlock.classList.toggle('is-unmuted', !muted);
          mediaBlock.classList.toggle('is-not-started', !hasStarted);
          playButton.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
          muteButton.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        };

        overlayPlayButton.addEventListener('click', function () {
          var video = getVideo();
          if (!video) return;
          hasStarted = true;
          video.play();
          syncState();
        });

        playButton.addEventListener('click', function () {
          var video = getVideo();
          if (!video) return;
          if (video.paused) {
            hasStarted = true;
            video.play();
          } else {
            video.pause();
          }
          syncState();
        });

        muteButton.addEventListener('click', function () {
          var video = getVideo();
          if (!video) return;
          video.muted = !video.muted;
          syncState();
        });

        var video = document.createElement('video');
        video.className = 'welcome-splash__video video-section__video';
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.muted = true;
        video.autoplay = true;
        var source = document.createElement('source');
        source.src = url;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.addEventListener('ended', showWelcome);
        video.addEventListener('error', showWelcome);
        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('volumechange', syncState);
        videoStage.appendChild(video);

        window.addEventListener('resize', syncState, { passive: true });

        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            hasStarted = false;
            syncState();
          });
        }
        syncState();
      }
    }

    var dismissTarget = root.querySelector('[data-welcome-splash-dismiss]');
    if (dismissTarget) {
      dismissTarget.addEventListener('click', function () {
        dismiss({ fade: true });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
